import { render, staticRenderFns } from "./IndicatorsIceChartTable.vue?vue&type=template&id=12b1ea78&scoped=true"
import script from "./IndicatorsIceChartTable.vue?vue&type=script&lang=js"
export * from "./IndicatorsIceChartTable.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsIceChartTable.vue?vue&type=style&index=0&id=12b1ea78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1ea78",
  null
  
)

export default component.exports